<template>
  <b-modal
    id="modal-verificar-celular"
    title="Verificação de celular"
    size="md"
    variant="dark"
    hide-footer
    no-close-on-backdrop
    @hidden="fechouModal"
    @shown="abriuModal"
  >
    <div v-if="loadingGeral" class="text-center">
      <div class="py-3 wiggle">
        <i class="fas fa-mobile-alt fa-3x text-muted"></i>
        <i class="fas fa-sms fa-2x text-success"></i>
      </div>
      <div>Enviando o SMS... Por favor, aguarde.</div>
      
    </div>

    <div class="text-center" v-else>
      <div class="py-3">
        <i class="fas fa-mobile-alt fa-3x text-muted"></i>
        <i class="fas fa-sms fa-2x text-success"></i>
      </div>
      <p class="px-3">
        Dentro de instantes você receberá um SMS no celular contendo um
        <b>código de verificação</b>.
      </p>

      <div class="row">
        <div class="col-sm-6 offset-sm-3">
          <input
            ref="inputCodigo"
            type="text"
            class="form-control"
            placeholder="_ _ _ _ _"
            maxlength="5"
            v-model="codigo"
          />
          <button class="btn btn-link btn-sm" @click="onClickNaoRecebeu" :disabled="aguardandoNovaTentativa">
            Ainda não recebeu?
            <div v-if="aguardandoNovaTentativa"> Por favor aguarde {{tempoNovaTentativa}}s</div>
            <div v-else>Clique aqui</div>
          </button>
          <button
            class="btn btn-primary btn-block mt-3"
            @click="onClickVerificar"
            :disabled="!temCodigoDigitado() || loadingVerificacao"
          >
            <span v-if="loadingVerificacao">Verificando...</span>
            <span v-else>Verificar</span>
          </button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Swal from "sweetalert2";
import axios from "axios";
import config from "../../config";
import helper from "../../helpers/helper";
import captureError from "../../helpers/captureError";

export default {
  props: ["celular"],
  data() {
    return {
      loadingGeral: false,
      loadingVerificacao: false,

      codigo: undefined,
      verificado: undefined,
      aguardandoNovaTentativa: false,
      tempoNovaTentativa: undefined,
      idTimerNovaTentativa: undefined
    };
  },
  methods: {
    onClickVerificar() {
      //   if(!this.temCodigoDigitado()){
      //       return;
      //   }
      this.verificarCodigo();
    },
    onClickNaoRecebeu() {
      this.verificado = undefined;
      this.codigo = undefined;
      this.iniciarVerificacao();
    },
    temCodigoDigitado() {
      return this.codigo && this.codigo.length >= 4;
    },
    async iniciarVerificacao() {
      try {
        this.loadingGeral = true;

        var numero = helper.getOnlyNumbers(this.celular);
        await axios.get(
          `${config.API_URL}/cliente/IniciarValidacaoCelular?numero=${numero}`
        );

        this.loadingGeral = false;

        setTimeout(()=>{
          this.$refs.inputCodigo.focus();
        },700);

        this.iniciarTempoNovaTentativa();

      } catch (e) {
        captureError(e);

        this.loadingGeral = false;

        await Swal.fire({
          icon: "error",
          title: "Oops...",
          text:
            "Não foi possível iniciar a verificação do celular. Tente novamente mais tarde ou contate o suporte.",
        });

        //Fecha a modal
        this.$bvModal.hide("modal-verificar-celular");
      }
    },
    async verificarCodigo() {
      try {
        this.loadingVerificacao = true;

        var response = await axios.post(
          `${config.API_URL}/cliente/ValidacaoCelular?codigo=${this.codigo}`,
          {}
        );

        this.verificado = response.data?.validado;

        this.loadingVerificacao = false;

        await Swal.fire({
          icon: "success",
          title: "Verificado com sucesso!",
        });
      } catch (e) {
        this.loadingVerificacao = false;

        this.verificado = e.response?.data?.validado;

        if (this.verificado === false) {
          await Swal.fire({
            icon: "warning",
            title: "Oops... código incorreto",
          });
        } else {
          captureError(e);
          await Swal.fire({
            icon: "error",
            title: "Oops...",
            text:
              "Não foi possível realizar a verificação do celular. Tente novamente mais tarde ou contate o suporte.",
          });
        }
      }

      //Fecha a modal
      this.$bvModal.hide("modal-verificar-celular");
    },
    iniciarTempoNovaTentativa(){

      this.aguardandoNovaTentativa = true;
      this.tempoNovaTentativa = config.TEMPO_SEGUNDOS_ENVIAR_SMS_CODIGO_VALIDACAO_CELULAR;
      this.idTimerNovaTentativa = setInterval(()=>{
        this.tempoNovaTentativa = this.tempoNovaTentativa - 1;

        if(this.tempoNovaTentativa == 0){
          clearInterval(this.idTimerNovaTentativa);
          this.aguardandoNovaTentativa = false;
        }
      },1000);

    },
    fechouModal() {
      this.$emit("verificado", this.verificado);
    },
    abriuModal() {
      this.codigo = undefined;
      this.verificado = undefined;
      this.iniciarVerificacao();
    },
  },
};
</script>

<style scoped>
input {
  text-transform: uppercase;
  text-align: center;
  font-size: 1.5rem;
}
</style>
